module.exports = __webpack_public_path__ + "static/BirdsEye-d9fe47b1a16f3e901a2efd296b3f3996.mp4";